import { ProductApiResponse } from '../../models/product-api/product-api-reponse';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Tools } from '../helpers/tools';
import { HttpClient } from '@angular/common/http';
import { HttpMethod, RestService } from '../rest.service';
import { SearchInput } from './search-input';
import { firstValueFrom } from 'rxjs';
import { valueIsEan } from '../helpers/ean-helper';

const BASE_URL = environment.castorama.productApi.searchUrl;
const TOKEN = environment.castorama.productApi.token;

@Injectable({
  providedIn: 'root',
})
export class ProductApiService extends RestService {
  protected response: ProductApiResponse;

  constructor(public http: HttpClient) {
    super();
  }

  /**
   * Envoie une requête à la productApi KingFisher pour récupérer un ou plusieurs objet(s)
   * @param input Dto contenant les paramètres possible pour la requête
   * @param input.textInput valeur de la recherche textuelle de l'utilisateur
   * @param input.sortParam valeur utilisé pour le tri de la requête
   * @param input.page valeur pour la page de la requête. Pour la productApi la 1ère page est 1 pas 0
   */
  public async sendSearchRequest(input: SearchInput): Promise<ProductApiResponse> {
    // Ajout d'un tri s'il y en a un
    let sortParams = '';
    if (input.sortBy != null && input.sortBy.length > 0) {
      sortParams = '&sort=' + input.sortBy;
    }

    const isEan = valueIsEan(input.searchTerm);
    const pageParam = '&page[number]=' + input.page;
    const soldByCastoFilter = '&filter[Vendu+par]=Castorama';
    const includeProductsFilter = '&includeProducts=true';

    let filter = '';
    if (isEan) {
      filter = 'filter[ean]=' + input.searchTerm;
    } else {
      // Nettoyage de la recherche textuelle
      filter = 'searchTerm=' + Tools.replaceSpaceWithPlusSign(input.searchTerm);
    }

    const completeUrl = BASE_URL + filter + sortParams + pageParam + soldByCastoFilter + includeProductsFilter;
    return await firstValueFrom(this.restApi({ method: HttpMethod.GET, url: completeUrl }, { Authorization: TOKEN }));
  }
}
